export enum AuthenticationState {
  Restoring = 'Restoring',
  Authenticated = 'Authenticated',
  Unauthenticated = 'Unauthenticated'
}

export enum Role {
  SuperAdmin = 'SuperAdmin',
  Admin = 'Admin',
  Manager = 'Manager',
  Staff = 'Staff'
}
